// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2278t","content":"styles_content__t_HsT","checkbox":"styles_checkbox__jKtSo","checkboxLabel":"styles_checkboxLabel__2C14e"};